import { FaxTypes } from '@frontend/api-fax';

export const getFaxIdFromURL = (url: string, type: FaxTypes.InboxType) => {
  const regexPattern = new RegExp(`/${type}/([^/]+)`);

  const match = url.match(regexPattern);

  return match ? match[1] : null;
};
